/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import {
  Card, Alert, Typography, Link
} from '@one-thd/sui-atomic-components';
import PropTypes from 'prop-types';
import ListsHeader from './ListsHeader';

const ListsError = ({ refetchLists }) => {

  return (
    <Card
      data-component="Lists"
      data-testid="lists-error-container"
      className="sui-@container sui-h-full"
    >
      <ListsHeader
        listCount={0}
        showLearnMoreLink={false}
        hideActions
        showOnlyCreate
      />
      <Alert status="error" size="large">
        <div>
          <Typography variant="body-base" weight="bold">Something went wrong during loading</Typography>
          <Typography variant="body-base">
            <Link onClick={refetchLists}>Refresh Lists</Link> to try again.
          </Typography>
        </div>
      </Alert>
    </Card>
  );
};
ListsError.displayName = 'ListsError';
ListsError.propTypes = {
  refetchLists: PropTypes.func
};
ListsError.defaultProps = {
  refetchLists: () => {}
};
export default ListsError;